import React, { useEffect, useRef, useState } from "react";
import { signInAsGuest, useAuth } from "../auth/FirebaseAuth.js";
import { useNavigate, useParams } from "react-router-dom";

import Divider from "../layout/Divider.js";
import Icon1 from "../icons/Icon.js";
import Space from "../layout/Space.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import { Skeleton } from "@mui/material";
import {
  createDoc,
  getDocDataById,
  getDocDataByRef,
  getOrgDataById,
  updateDocDataField,
} from "../models/DataFunctions.js";
import { sendSmsVerificationCall } from "../config/ApiCalls.js";
import { gatherDeviceInfo } from "../config/GatheringInfos.js";
import { useSnackbar } from "notistack";
import TextField2 from "../textfields/TextField2.js";
import { VerifySmsCodeCall } from "../config/ApiCalls.js";
import { useAppContext } from "../config/AppContext.js";
import getTemporaryUrl from "../api/getTemporaryUrl.js";
import PDF from "../pdf/PDF.js";
import Modal1 from "../modals/Modal1.js";
import signDevis from "../api/sign/signDevis.js";
import sendEmail from "../api/send/sendEmail.js";
import { version, GlobalWorkerOptions, getDocument } from "pdfjs-dist";
import SmallSpinner from "../loading/SmallSpinner.js";
import SignaturePad from "../sign/SignaturePad.js";
import sendTamponDevisBase64 from "../api/sign/sendTamponDevisBase64.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import TextFieldEmail from "../textfields/TextFieldEmail.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import sendRequest from "../api/send/sendRequest.js";
import ParticulierHeader from "../modals/ParticulierHeader.js";
import sendGuestText from "../api/sign/sendGuestText.js";
import { BoldBlackButton } from "./Rapport.js";
import { Spin } from "antd";
GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.min.js`;
import createDocApi from "../api/database/createDocApi.js";

function InvoiceSign({ navigateWorkspace }) {
  const { id } = useParams(); // Access the `id` parameter from the URL
  const [invoiceData, setInvoiceData] = useState(null);
  const [masterData, setMasterData] = useState(null);
  const [sign_name, setSignName] = useState("");
  const [loadingUrl, setLoadingUrl] = useState(false);
  const [loading1, setLoading1] = useState(true);
  const [link_dead, setLink_dead] = useState(false);
  const [step, setStep] = useState(1);
  const [code, setCode] = useState("");
  const [sign_url, setSign_url] = useState("");
  const [signal_open, setSignalOpen] = useState(false);
  const [message, SetMessage] = useState("");
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [conditions_open, setConditionsOpen] = useState(false);
  const { currentUser, loading } = useAuth();
  const [visualisation_open, setVisualisationOpen] = useState(false);
  // Fetch user, org, clients, and article data

  const openSmsPortal = () => {
    navigateWorkspace(
      "/smsportal/" + id + "?auth_type=devis&redirect_url=invoice-sign/" + id
    );
  };

  const handleFetchData = async () => {
    try {
      const user = await getUserById(currentUser.uid); // Fetch user by ID using function
      if (user) {
        console.warn("This should only be a guest user");
        let path = window.location.pathname;

        await handleLogout(path);
        return;
      }
    } catch (error) {}

    try {
      let key = await generateKey();
      await getTemporaryUrl("vide", "devis", "", id, prefix, key);
      let invoice = await getDocDataById("devis", id);
      if (!invoice) {
        setLink_dead(true);
        console.warn("Link is dead because invoice is null");
      } else {
        if ((!currentUser && !loading) || currentUser.email) {
          setStep(7);
        }

        if (!currentUser && !loading) {
          if (invoice.state !== "wait") {
            setLink_dead(true);
            console.warn("Link is dead because state is " + invoice.state);
            setStep(-10);
          } else {
            setStep(7);
          }
        } else {
          if (invoice.state === "done") {
            setStep(4);
            handleLoadUrl();
          } else {
            setStep(3);
          }
        }

        invoice = await getDocDataById("devis", id);
        setInvoiceData(invoice);
      }
      setLoading1(false);
      // Fetch user data
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleVerifyCode = async (event) => {
    event.preventDefault();
    try {
      let res = await VerifySmsCodeCall("devis", id, code, prefix);
      if (res.success) {
        handleClickVariant("Code SMS correct", "success"); // Success notification
        const data = {
          creation_date: new Date(),
        };
        await signInAsGuest(res.token);
        let token = await getOrRefreshFirebaseToken();
        await getTemporaryUrl(token, "devis", "", id, prefix);
        let invoiceData = await getDocDataById("devis", id);
        let master = await getOrgDataById(invoiceData.org_id);
        setInvoiceData(invoiceData);
        setMasterData(master);
        setStep(3);
        setConditionsOpen(true);
      } else {
        handleClickVariant("Code SMS incorrect", "error"); // Error notification
      }
    } catch (error) {
      handleClickVariant("Code SMS incorrect", "error"); // Error notification
      console.error("Error logging in:", error.message);
    }
  };
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [loadingData, setLoadingData] = useState(false);

  useEffect(() => {
    if (invoiceData) {
      if (!invoiceData?.file?.url) {
        handleLoadUrl();
      }
    }
  }, [invoiceData]);
  const [loadingSignedUrl, setLoadingSignedUrl] = useState(false);

  const handleOpenInvoice = async () => {
    setLoadingSignedUrl(true);

    await handleLoadUrl();
    let fresh_invoice = await getDocDataById("devis", invoiceData.id);

    if (fresh_invoice?.file?.url) {
      window.open(fresh_invoice?.file?.url, "_blank");
    }
    setLoadingSignedUrl(false);
  };
  const handleLoadUrl = async () => {
    let token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(token, "devis", "", id, prefix);
    const invoice = await getDocDataById("devis", id);
    setInvoiceData(invoice);
    setVisualisationOpen(true);
  };
  const getPDFDimensions = async (pdfUrl) => {
    try {
      const loadingTask = getDocument(pdfUrl);
      const pdf = await loadingTask.promise;

      if (!pdf) {
        console.error("PDF document is null");
        return { width: 595, height: 842 }; // Default A4 dimensions
      }

      const page = await pdf.getPage(1);

      if (!page) {
        console.error("PDF page is null");
        return { width: 595, height: 842 }; // Default A4 dimensions
      }

      const viewport = page.getViewport({ scale: 1 });

      const width = viewport.width;
      const height = viewport.height;

      return { width, height };
    } catch (error) {
      console.error("Error getting PDF dimensions:", error);
      return { width: 595, height: 842 }; // Default A4 dimensions
    }
  };

  const handleSign = async () => {
    try {
      if (sign_name === "") {
        handleClickVariant(
          "Veuillez ajouter un nom pour la signature",
          "error"
        );
        return;
      }
      if (sign_name.length > 16) {
        handleClickVariant(
          "Le nom ne doit pas dépasser 16 caractères",
          "error"
        );
        return;
      }
      setLoadingData(true);

      let token = await getOrRefreshFirebaseToken();
      const img_url = await sendGuestText(sign_name, token, prefix);

      let newchamps = invoiceData.champs;
      for (let i = 0; i < newchamps.length; i++) {
        if (newchamps[i].type === "Signature") {
          newchamps[i].content = img_url;
        }
        if ("bb" in newchamps[i]) {
          newchamps[i].x = newchamps[i].bb;
        }
        if ("pp" in newchamps[i]) {
          newchamps[i].y = newchamps[i].pp;
        }
        if ("hh" in newchamps[i]) {
          newchamps[i].h = newchamps[i].hh;
        }
        if ("ww" in newchamps[i]) {
          newchamps[i].w = newchamps[i].ww;
        }
      }

      token = await getOrRefreshFirebaseToken();
      await getTemporaryUrl(token, "devis", "", id, prefix);
      token = await getOrRefreshFirebaseToken();
      console.log("invoiceData.file.url", invoiceData.file.url);
      console.log("trying to get PDF Dimensions");
      const { width, height } = await getPDFDimensions(invoiceData.file.url);

      await signDevis(
        newchamps,
        invoiceData.file.url,
        token,
        invoiceData.id,
        prefix,
        height,
        width
      );
      handleClickVariant("Devis signé", "success");
      setStep(4);
      setLoadingData(false);
    } catch (e) {
      console.error("Error signing invoice ", e);
      setLoadingData(false);
    }
  };

  const handleSendRequest = async () => {
    const token = await getOrRefreshFirebaseToken();

    await sendRequest(
      "particulier",
      message,
      invoiceData.email_client,
      invoiceData.tel_client,
      "request",
      token,
      prefix
    );
    handleClickVariant("Message envoyé avec succès", "success");
    setSignalOpen(false);
  };

  const handleSendErrorEmail = async () => {
    setStep(-1);
    await updateDocDataFieldApi(invoiceData.ref, "state", "error", prefix);
    let token = await getOrRefreshFirebaseToken();
    let client = await getOrgDataById(invoiceData.client_id);
    let master = await getOrgDataById(invoiceData.org_id);
    let sujet = "Mauvais numéro rensigné pour signature de devis.";
    let date = new Date(invoiceData.creation_date.seconds * 1000);
    let message = `Le devis envoyé à ${invoiceData.nom_client} ${invoiceData.adresse_client}, le ${date.toLocaleDateString()} n'a pas pu être signé. Veuillez vérifier le numéro de téléphone et l'adresse email renseignés pour la signature.`;
    await sendEmail(message, master.email, sujet, token, prefix);
    handleClickVariant("Un email a été envoyé à votre partenaire", "success");
  };

  const [signType, setSignType] = useState(0);
  const [signready, setSignReady] = useState(false);

  const setReady = () => {
    setSignReady(true);
  };

  const handleSendSms = async () => {
    const infos = gatherDeviceInfo();
    sendSmsVerificationCall("devis", id, infos, prefix);
    handleClickVariant("Un SMS de vérification a été envoyé", "success");
    setStep(2);
  };
  useEffect(() => {
    if (loading === false) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [loading, id, currentUser]); // Dependency array ensures this runs when currentUser changes

  function hideParttially(str) {
    return str.slice(0, 3) + "****" + str.slice(-3);
  }

  if (loading1) {
    return (
      <div className="w-full h-full overflow-auto flex flex-row gap-2 mt-3"></div>
    );
  }

  return (
    <div className="flex flex-col w-full h-full  overflow-auto align-middle items-center justify-center ">
      <Modal1 isOpen={signal_open} onClose={() => setSignalOpen(false)}>
        <div className="bg-gray-100 flex flex-col p-4 w-c400 rounded-3xl ">
          <div className="flex flex-col gap-3 w-full">
            <div className="flex flex-row justify-between">
              {" "}
              <div className="text-h3">Message au support</div>
              <div
                className="text-h3 text-shadow_50 cursor-pointer"
                onClick={() => setSignalOpen(false)}
              >
                Fermer
              </div>
            </div>
            <TextFieldEmail
              label="Message"
              value={message}
              onChange={(e) => SetMessage(e.target.value)}
            ></TextFieldEmail>
            <div className="w-full justify-end flex">
              <PrimaryButton className="w-fit" onClick={handleSendRequest}>
                Envoyer
              </PrimaryButton>
            </div>
          </div>
        </div>
      </Modal1>
      <Modal1 isOpen={conditions_open} onClose={() => setConditionsOpen(false)}>
        <div className="flex flex-col max-w-c400 sm:max-w-c500 h-fit ">
          <div className="flex flex-col justify-start items-start h-fit p-4 bg-white rounded-3xl shadow-xl  w-full select-none ">
            <div className="flex flex-col gap-1 mb-2 w-full items-center">
              <div className="text-h2 text-center mb-2">Signature du devis</div>
              <img src={masterData?.logo} className="w-c50 h-c50 rounded-lg" />
            </div>

            <div className="flex flex-col gap-1 text-h4 text-shadow_50 mt-2 text-start w-full max-w-full overflow-auto scale-100 h-fit max-h-c150 sm:max-h-screen  ">
              Vous êtes sur une interface sécurisée, propulsée par hexagone,
              l’outil utilisé par votre bureau de contrôle en infiltrométrie
              pour la gestion et le suivi de votre intervention.
              <div className="mt-2">Informations du devis :</div>
              <ul className="flex flex-col gap-1 list-disc pl-8 my-2">
                <li>Bureau de contrôle : {masterData?.name}</li>

                <li>
                  Adresse du projet :{" "}
                  {invoiceData?.adresse_projet +
                    " " +
                    invoiceData?.postal_projet +
                    " " +
                    invoiceData?.ville_projet}
                </li>
                <li>Nom du particulier : {invoiceData?.nom}</li>
                <li>Email du particulier : {invoiceData?.email_client}</li>
                <li>Téléphone du particulier : {invoiceData?.tel_client}</li>
              </ul>
            </div>

            <div className="w-full flex flex-row justify-center mt-4">
              <div
                className="max-w-c300 rounded-lg bg-black text-white w-full shadow-md cursor-pointer hover:shadow-shadow_25 flex justify-center text-h2 px-4 py-2 font-semibold"
                onClick={() => setConditionsOpen(false)}
              >
                Accepter
              </div>
            </div>

            <div className="text-h4 mt-4 text-shadow_50 text-center w-full ">
              En cliquant sur "Accepter", vous confirmez votre signature en
              toute sécurité et vous acceptez nos
              <span
                className="hover:text-black cursor-pointer"
                onClick={() =>
                  window.open(
                    "https://hexagone.expert/legal/conditions-utilisation#section"
                  )
                }
              >
                {" "}
                Conditions d'utilisation du service{" "}
              </span>
              et notre
              <span
                className="hover:text-black cursor-pointer"
                onClick={() =>
                  window.open(
                    "https://hexagone.expert/legal/confidentialite#section"
                  )
                }
              >
                {" "}
                Politique de confidentialité
              </span>
              .
            </div>

            <div className="text-h4 mt-4 text-shadow_50 text-center w-full ">
              Site du partenaire :
              <span
                className="hover:text-black cursor-pointer font-semibold text-indigo-500"
                onClick={() => window.open("https://www.hexagone.expert")}
              >
                {" "}
                hexagone
              </span>
            </div>
          </div>
        </div>
      </Modal1>
      {/* Left Column: Takes all available space */}
      {link_dead && (
        <div className="flex flex-col w-fit h-fit p-4 gap-2 bg-white rounded-3xl shadow-xl overflow-auto items-center  ">
          <Icon1 icon_name="warning" fill="" />
          <div className="text-h2 text-center">Ce lien a expiré</div>
        </div>
      )}
      {step === -1 && (
        <div className="flex flex-col w-fit h-fit p-4 gap-2 bg-white rounded-3xl shadow-xl overflow-auto items-center ">
          <Icon1 icon_name="cloche" fill="" />
          <div className="text-h2 text-center">
            Votre partenaire a été notifié.
          </div>
          <div className="text-h2 text-shadow_50 text-center w-c250">
            Il va vous contacter pour récupérer le bon numéro de téléphone et
            relancer la procédure.
          </div>
          <div className="text-h2 text-shadow_50 text-center w-c250">
            Vous pouvez fermer cette page.
          </div>
        </div>
      )}
      {step === 1 && invoiceData && (
        <div className="flex flex-col w-fit h-fit p-4 gap-2 bg-white rounded-3xl shadow-xl overflow-auto items-center ">
          <Icon1 icon_name="smartphone" fill="" />
          <div className="text-h2 text-center w-c250">
            Vous allez recevoir un sms pour confirmer votre identité.
          </div>
          <div className="text-h2 text-center w-c250">
            Est-ce que ce numéro de téléphone est bien le vôtre ?
          </div>
          <div className=" rounded-xl py-0.5 text-shadow_50 bg-neutral-200 px-2 text-h2 font-semibold w-fit">
            {hideParttially(invoiceData.tel_client)}
          </div>{" "}
          <div className="flex flex-row gap-2">
            <SecondaryButton onClick={handleSendErrorEmail}>
              Non
            </SecondaryButton>
            <PrimaryButton onClick={handleSendSms}>Oui</PrimaryButton>
          </div>
        </div>
      )}
      {step === 2 && invoiceData && (
        <div className="flex flex-col w-fit h-fit p-4 gap-2 bg-white rounded-3xl shadow-xl overflow-auto items-center ">
          <Icon1 icon_name="smartphone" fill="" />
          <div className="text-h2 text-center w-c250">
            Entrez le code que vous avez reçu.
          </div>
          <TextField2
            label="Code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          ></TextField2>
          <div className="flex flex-row gap-2">
            <SecondaryButton onClick={() => setStep(1)}>Retour</SecondaryButton>
            <PrimaryButton onClick={handleVerifyCode}>Vérifier</PrimaryButton>
          </div>
        </div>
      )}
      {step === 7 && invoiceData && (
        <div className="flex flex-col w-full max-w-c800 h-fit p-4 gap-2 bg-white rounded-3xl shadow-xl overflow-auto items-center ">
          <>
            <div className="hidden h-fit w-full  flex-col max-w-c800 sm:flex  ">
              <PDF files={[invoiceData.presign_file]}></PDF>{" "}
              <div className="flex flex-row justify-end w-full  items-center p-4">
                <PrimaryButton onClick={openSmsPortal}>
                  Signer le devis
                </PrimaryButton>
              </div>
            </div>
          </>
        </div>
      )}
      {step === 3 && invoiceData && (
        <div className="flex flex-col w-full h-full  p-6 bg-white  shadow-xl overflow-auto mb-auto sm:mb-0">
          <Modal1
            isOpen={visualisation_open}
            onClose={() => setVisualisationOpen(false)}
          >
            <div className=" h-screen w-screen bg-white relative  ">
              <PDF files={[invoiceData.presign_file]} defaultScale={0.8}></PDF>
              <div className="absolute top-0 right-0 px-4 py-2">
                <SecondaryButton onClick={() => setVisualisationOpen(false)}>
                  Fermer
                </SecondaryButton>
              </div>
            </div>
          </Modal1>
          <div className="flex flex-col gap-2">
            <div className="text-h2 text-left font-semibold w-c250">
              Signature du devis
            </div>
            <div className="text-h2 text-shadow_50 max-w-c400">
              Bienvenue dans l'interface de signature d'hexagone, lisez le devis
              puis procédez à l'ajout de votre signature pour finaliser la
              signature de ce devis.
            </div>
          </div>
          <Space y={20}></Space>
          <div className="flex h-full flex-wrap gap-3 w-full ">
            {invoiceData?.presign_file?.url && (
              <>
                <div className="hidden h-fit w-full max-w-c800 sm:flex  ">
                  <PDF files={[invoiceData.presign_file]}></PDF>
                </div>
                <div className="flex h-fit w-full max-w-c800 sm:hidden  ">
                  <PrimaryButton onClick={handleLoadUrl}>
                    Voir le devis
                  </PrimaryButton>
                </div>
              </>
            )}
            <div className="flex flex-col h-full max-w-c400  ">
              <div className="flex flex-wrap max-w-c400 bg-white p-4 gap-3  rounded-xl h-fit border-1 border-shadow_10">
                <div className="text-h2 text-left font-semibold max-w-c250">
                  Signature
                </div>
                <div className="text-h2 text-shadow_50 max-w-c400">
                  Après avoir lu le devis à gauche, veuillez ajouter votre
                  signature ci-dessous pour signer le devis.
                </div>
                <Divider orientation="horizontal"></Divider>

                <div className="flex flex-col gap-2">
                  <div className="text-shadow_50 text-h2 font-semibold">
                    Ajoutez vos initiales
                  </div>
                  <div>
                    <TextField2
                      value={sign_name}
                      label="J. B."
                      onChange={(e) => setSignName(e.target.value)}
                    ></TextField2>
                    {sign_name && sign_name !== "" && (
                      <div
                        className=" bg-neutral-100 mt-4 alex-brush-regular "
                        style={{
                          fontSize: "50px",
                          color: "blue",
                          fontFamily: "Alex Brush",
                          textAlign: "center",
                        }}
                      >
                        {sign_name}
                      </div>
                    )}
                  </div>{" "}
                  <PrimaryButton
                    className="w-fit h-fit"
                    onClick={handleSign}
                    disabled={loadingData || sign_name === ""}
                  >
                    <div className="flex flex-row content-center align-middle items-center">
                      Signer le devis
                      <Space x={5} />
                      <SmallSpinner
                        loading={loadingData}
                        margin={0}
                        size={20}
                      />
                    </div>
                  </PrimaryButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {step === 4 && invoiceData && (
        <div className="flex flex-col w-fit h-fit p-4 gap-2 bg-white rounded-3xl shadow-xl overflow-auto items-center mt-4 sm:mt-0">
          <Icon1 icon_name="done2" size={20} fill="#13ef81" />
          <div className="text-h2 text-center w-c250">
            Le devis a été signé.
          </div>
          <BoldBlackButton
            onClick={handleOpenInvoice}
            loading={loadingData}
            disabled={invoiceData?.file?.url === null}
            ability_loading={
              loadingSignedUrl === false && invoiceData?.file?.url === null
            }
          >
            {loadingSignedUrl ? (
              <div className="flex flex-col gap-2">
                <SmallSpinner></SmallSpinner>
              </div>
            ) : (
              <>Voir le devis</>
            )}
          </BoldBlackButton>
        </div>
      )}

      <ParticulierHeader
        prefix={prefix}
        email={invoiceData?.email_client}
        phone={invoiceData?.tel_client}
      ></ParticulierHeader>
    </div>
  );
}

export default InvoiceSign;

export const generateKey = async () => {
  const data = {
    creation_date: new Date(),
  };
  const key = await createDoc("security_key", data);
  return key.id;
};
